// extracted by mini-css-extract-plugin
export default {"skipdatecontain":"xT","skip_info":"yT","skipped":"zT","modify_order":"AT","cancel_subscription_btn":"BT","byb":"CT","modify_order_outer":"ET","byb_edit_btn":"FT","modify_order_item":"GT","cancel_copy_wrapper":"HT","cancelled_copy":"IT"};
    if(module.hot) {
      // 1713996749452
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  